export default {
  card: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    p: theme.spacing(2, 2, 3),
    boxShadow: '0px 24px 24px rgba(174, 168, 207, 0.18)',
    [theme.breakpoints.down('lg')]: {
      maxWidth: 534,
      top: -6,
      p: theme.spacing(2, 2, 2, 2),
      borderRadius: '16px',
    },
    [theme.breakpoints.up('lg')]: {
      minWidth: 534,
      top: -80,
      left: {
        lg: 10,
        sm: 25,
      },
      p: theme.spacing(5, 7, 4),
      borderRadius: 10,
    },
  }),
  paymentItem: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    mt: 3,
    marginBottom: {
      xl: '0',
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  banksContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '30px',
    mt: { xs: 3, sm: 2 },
  },
};
